@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.dropdown-styled {
  width: 100%;
}

.warehouse-location-dropdown {
  width: 100%;
}

.cost-input {
  align-items: center;
}

.currency-input-small {
  height: 32px;
}

label.currency-symbol {
  min-width: 44px;
}
